import { render, staticRenderFns } from "./AttributeLocation.vue?vue&type=template&id=231c7ec9&"
import script from "./AttributeLocation.vue?vue&type=script&lang=js&"
export * from "./AttributeLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports